<template>
    <div
        class="o-sendingScreen"
        data-qa="sending overlay"
    >
        <div class="o-sendingScreen__overlay"/>
        <div class="k-c-modal__content o-sendingScreen__modalContent">
            <div class="o-sendingScreen__content flex flex-col items-center">
                <SupportiveCvSendEnvelopeSvg
                    class="o-sendingScreen__img mx-auto"
                    data-qa="sending scene"
                    alt=""
                />
                <TextHeadline
                    variant="md-700"
                    data-qa="headline"
                    class="o-sendingScreen__headline"
                >
                    Bewerbung wird gesendet
                </TextHeadline>
                <TextBase
                    data-qa="subheadline"
                    class="o-sendingScreen__subheadline"
                >
                    Das kann einen Moment dauern
                </TextBase>
                <LoadingDots
                    class="o-sendingScreen__loading"
                    data-qa="loading dots"
                />
            </div>
            <!-- Footer has to be on every page because of legal reasons. -->
            <AppFooter
                variant="small"
                class="o-sendingScreen__footer"
                data-qa="small footer"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onBeforeUnmount } from 'vue';
import TextHeadline from '../../atoms/app/text/TextHeadline.vue';
import AppFooter from '../AppFooter.vue';
import LoadingDots from '../../atoms/loading/LoadingDots.vue';
// eslint-disable-next-line import/no-unresolved
import SupportiveCvSendEnvelopeSvg from '../../../assets/img/supportive-cv-send-envelope.svg';
import { enableScrollingInBackground, preventScrollingInBackground } from '../../../utils/scrollingInBackground';
import TextBase from '../../atoms/app/text/TextBase.vue';

onBeforeMount(preventScrollingInBackground);
onBeforeUnmount(enableScrollingInBackground);
</script>

<style lang="scss">
@use 'sass:math';
@use '~@karriereat/global-styles/scss/components/modal/mixins';
@use '~@karriereat/global-styles/scss/settings/breakpoint';
@use '~@karriereat/global-styles/scss/settings/spacing';
@use '~@karriereat/global-styles/scss/tools/wrap';

$headerHeight: 60px;

.o-sendingScreen {
    &__modalContent {
        justify-content: flex-start;
        margin-top: spacing.$k-spacing--5xl;
    }

    &__content {
        @include wrap.k-wrap(math.div(6, 12));
        text-align: center;
    }

    &__img {
        width: 80%;

        @media (min-width: breakpoint.$k-breakpoint--m) {
            width: 60%;
        }
    }

    &__headline {
        margin-top: spacing.$k-spacing--2xl;
    }

    &__subheadline {
        margin-top: spacing.$k-spacing--xs;
    }

    &__loading {
        margin-top: spacing.$k-spacing--xl;
    }

    &__footer {
        position: fixed;
        bottom: 0;
    }
}
</style>
